exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btnposalji{\r\n    top: -10px;\r\n}\r\n\r\n.btnispisi{\r\n    top: -10px;\r\n}\r\n\r\n.btnizvezi{\r\n    top: -10px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.btnkreiraj{\r\n    top: -10px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.btnexcel{\r\n    top: -10px;\r\n}\r\n\r\n.upozorenje{\r\n    color: white;\r\n}\r\n\r\n::ng-deep .dx-pivotgrid .dx-pivotgrid-expanded .dx-expand:before{\r\n    display: none;\r\n}\r\n\r\n#kriteriji-Forma {\r\n    width: 100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/ucionica-detalji/ucionica-detalji.component.css
// module id = ../../../../../src/app/pages/virtualna-ucionica/ucionica-detalji/ucionica-detalji.component.css
// module chunks = main